const {atom} = require("recoil");

const badgeState = atom({
  key: 'badge',
  default: {},
});

export default badgeState;
